import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router';
import { AUTH_PROVIDER_PARAM_KEY, AUTH_TYPE_PARAM_KEY } from './use-auth-event';

export const useIsSocialLoginCallback = (defaultValue = false) => {
    const [searchParams] = useSearchParams();
    const [isSocialLoginCallback, setIsSocialLoginCallback] =
        React.useState(defaultValue);

    useEffect(() => {
        const providerParams = searchParams.get(AUTH_PROVIDER_PARAM_KEY);
        const authTypeParam = searchParams.get(AUTH_TYPE_PARAM_KEY);
        setIsSocialLoginCallback(!!providerParams && !!authTypeParam);
    }, [searchParams]);
    return isSocialLoginCallback;
};
